import PlayerPerformanceActionType from 'actions/playerPerformance/playerPerformanceActionType';

const initialState = {
  transactionAggregationLoading: null,
  aggregations: {},
};

const playerPerformanceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case PlayerPerformanceActionType.CHANGE_TRANSACTION_LOADING_STATE:
    return {
      ...state,
      transactionAggregationLoading: payload,
    };
  case PlayerPerformanceActionType.SAVE_PLAYERS_AGGREGATIONS:
    return {
      ...state,
      aggregations: payload.data,
    };
  case PlayerPerformanceActionType.RESET_PLAYERS_AGGREGATIONS:
    return {
      ...state,
      aggregations: {},
    };
  default:
    return state;
  }
};

export default playerPerformanceReducer;
